import { useRecordContext, useUpdate, useNotify } from 'react-admin'
import { Switch, FormControlLabel } from '@mui/material'

import { KID_SERIES_STATUSES } from './constants'

const KidSeriesStatusField = props => {
  const { disabled } = props
  const record = useRecordContext()
  const notify = useNotify()
  const [update] = useUpdate()

  const isPublished = record?.status === KID_SERIES_STATUSES.PUBLISHED

  const handleChange = () => {
    const next = isPublished
      ? KID_SERIES_STATUSES.UNPUBLISHED
      : KID_SERIES_STATUSES.PUBLISHED

    update(
      'kid-series',
      { id: record.id, data: { status: next }, previousData: record },
      {
        mutationMode: 'optimistic',
        onSuccess: () => notify('Update successfully', { type: 'info' }),
        onError: () => notify('Update failed', { type: 'error' }),
      },
    )
  }

  return [
    KID_SERIES_STATUSES.PUBLISHED,
    KID_SERIES_STATUSES.UNPUBLISHED,
  ].includes(record?.status) ? (
    <FormControlLabel
      control={
        <Switch
          checked={isPublished}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={record?.status}
    />
  ) : (
    record?.status || null
  )
}

export default KidSeriesStatusField
